<template>
  <span>
    <span v-html="header"/>
    <xc-region-selector v-if="regionSelectorVisible" @close="close()"/>
  </span>
</template>

<script>
import axios from 'axios'
import xcHelperMixin from '../mixins/xc-helper'
import XcRegionSelector from './XcRegionSelector'
import { mapState } from 'vuex'
import { i18n } from '../plugins/vue-i18n'

export default {
  name: 'Header',
  components: {XcRegionSelector},
  mixins: [xcHelperMixin],
  data () {
    return {
      header: null,
      languageSelector: null,
      regionSelectorVisible: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  watch: {
    user: function (newUser) {
      this.updateUserElements(newUser)
    }
  },
  async created () {
    await this.getHeader()

    window.activateSearch = () => this.activateSearch()
    window.closeSearch = () => this.closeSearch()
    this.autoCompleteSearch()
    this.initiateFontToggler()
    this.regionSelectorListener()
    this.languageSelectorListener()
    this.mobileMenu()
    this.updateUserElements(this.user)
    this.initiateSkipToContentLink()
  },
  methods: {
    async getHeader () {
      const response = await axios.get(`/header/${i18n.locale}`)
      this.header = response.data
    },
    close () {
      this.regionSelectorVisible = false
    },
    languageSelectorListener () {
      this.languageSelector = this.$el.querySelector('[id^="languageSwitch"]')
      this.languageSelector.addEventListener('change', e => this.onLanguageSwitch(e))
    },
    async onLanguageSwitch (e) {
      e.preventDefault()
      const selectedOption = e.target.selectedOptions[0]
      i18n.locale = selectedOption.getAttribute('data-lang-id')

      this.$router.push({
        ...this.$route,
        params: {
          lang: i18n.locale
        }
      }).catch(() => {})

      await this.retrieveHeaderAndFooter(i18n.locale)

      this.$emit('switchLanguage', i18n.locale)

      // Re-attach because header has been replaced
      this.languageSelector.removeEventListener('change', this.onLanguageSwitch)
      this.languageSelector = this.$el.querySelector('[id^="languageSwitch"]')
      this.languageSelector.addEventListener('change', e => this.onLanguageSwitch(e))
      // Restore value
      this.languageSelector.value = selectedOption.value
    },
    regionSelectorListener () {
      const regionSelectorButton = this.$el.querySelector('.region-selector-trigger')
      regionSelectorButton.addEventListener('click', e => {
        e.preventDefault()
        this.regionSelectorVisible = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue